/* eslint-disable no-unused-vars */

export enum translationTaskConstant {
  GET_TRANSLATION_TASKS = 'GET_TRANSLATION_TASKS',
  UPDATE_TRANSLATION_TASKS = 'UPDATE_TRANSLATION_TASKS',
  UPDATE_STATUS_TRANSLATION_TASK = 'UPDATE_STATUS_TRANSLATION_TASK',
  UPDATE_CURRENT_TRANSLATION_TASK = 'UPDATE_CURRENT_TRANSLATION_TASK',
  UPDATE_PROCESS_TRANSLATION_TASK_ID = 'UPDATE_PROCESS_TRANSLATION_TASK_ID',
  UPDATE_TEMPORARY_TRANSLATION_TASK_ID = 'UPDATE_TEMPORARY_TRANSLATION_TASK_ID',
  UPDATE_CURRENT_TRANSLATION_TASK_DATA = 'UPDATE_CURRENT_TRANSLATION_TASK_DATA',
  UPDATE_CURRENT_TRANSLATED_FILES = 'UPDATE_CURRENT_TRANSLATED_FILES',
  CLEAR_CURRENT_TASK_SELECTED_FILES_TRANSLATION = 'CLEAR_CURRENT_TASK_SELECTED_FILES_TRANSLATION',
  CLEAR_CURRENT_TASK_SELECTED_LANGUAGES_TRANSLATION = 'CLEAR_CURRENT_TASK_SELECTED_LANGUAGES_TRANSLATION',
  CLEAR_TEMPORARY_TRANSLATION_TASK = 'CLEAR_TEMPORARY_TRANSLATION_TASK',
  LOAD_TEMPORARY_TRANSLATION_TASK_DATA = 'LOAD_TEMPORARY_TRANSLATION_TASK_DATA',
  GET_LATEST_TRANSLATION_TASK = 'GET_LATEST_TRANSLATION_TASK',
  GET_DETAIL_TRANSLATION_TASK = 'GET_DETAIL_TRANSLATION_TASK',
  REQUEST_TRANSLATION = 'REQUEST_TRANSLATION',
  ADD_TRANSLATION_TASK = 'ADD_TRANSLATION_TASK',
  UPDATE_NEW_ANSWER_TRANSLATION_TASK = 'UPDATE_NEW_ANSWER_TRANSLATION_TASK',
  EDIT_TRANSLATION_TASK_NAME = 'EDIT_TRANSLATION_TASK_NAME',
  DELETE_TRANSLATION_TASK = 'DELETE_TRANSLATION_TASK',
  UPDATE_LIMIT_STATUS_TRANSLATION_TASK = 'UPDATE_LIMIT_STATUS_TRANSLATION_TASK',
  ADD_SELECTED_TRANSLATION_FILE = 'ADD_SELECTED_TRANSLATION_FILE',
  UPDATE_SELECTED_TRANSLATION_FILE = 'UPDATE_SELECTED_TRANSLATION_FILE',
  UPDATE_TRANSLATED_FILE = 'UPDATE_TRANSLATED_FILE',
  REMOVE_SELECTED_TRANSLATION_FILE = 'REMOVE_SELECTED_TRANSLATION_FILE',
  UPDATE_TRANSLATION_FILE_STATUS = 'UPDATE_TRANSLATION_FILE_STATUS',
  UPDATE_TRANSLATED_FILE_STATUS = 'UPDATE_TRANSLATED_FILE_STATUS',
  UPDATE_INITIAL_SELECTED_TRANSLATION_FILES = 'UPDATE_INITIAL_SELECTED_TRANSLATION_FILES',
  RESET_TRANSLATION_DATA = 'RESET_TRANSLATION_DATA',
  ADD_NEW_LANGUAGE_SELECTION = 'ADD_NEW_LANGUAGE_SELECTION',
  GET_ALL_LANGUAGE_SELECTIONS = 'GET_ALL_LANGUAGE_SELECTIONS',
  FETCH_ALL_LANGUAGE_DATA = 'FETCH_ALL_LANGUAGE_DATA',
  FETCH_ALL_LANGUAGE_DATA_SUCCESS = 'FETCH_ALL_LANGUAGE_DATA_SUCCESS',
  SET_INPUT_LANGUAGE = 'SET_INPUT_LANGUAGE',
  SET_OUTPUT_LANGUAGE = 'SET_OUTPUT_LANGUAGE',
  UPDATE_DOWNLOAD_TRANSLATED_FILE_STATUS = 'UPDATE_DOWNLOAD_TRANSLATED_FILE_STATUS',
  REQUEST_DOWNLOAD_ALL_TRANSLATED_FILES = 'REQUEST_DOWNLOAD_ALL_TRANSLATED_FILES',
}
